import Note from './note'

Note.install = vue => vue.component(Note.name, Note)

export default Note
